export const getAnimationDelay = (order?: number): string | undefined =>
  order ? `${order * 80}ms` : undefined;
